import React from "react"

import "./LoadingCircle.css"

const LoadingCircle = ({ className }) => {
  return <div className={`loading-circle ${className ? className : ""}`} />
}

export default LoadingCircle
